var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentRequirements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document--requirements_svg__clip0_61530_7200)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.442 15.442L16.5 20.385l-1.943-1.943L13.5 19.5l3 3 6-6-1.058-1.058zM12 15H7.5v1.5H12V15zM13.5 12h-6v1.5h6V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3h6v4.5c0 .825.675 1.5 1.5 1.5H18v4.5h1.5v-6a.682.682 0 00-.225-.525l-5.25-5.25A.681.681 0 0013.5 1.5H6c-.825 0-1.5.675-1.5 1.5v18c0 .825.675 1.5 1.5 1.5h5.25V21H6V3zm7.5.3l4.2 4.2h-4.2V3.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document--requirements_svg__clip0_61530_7200"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocumentRequirements;